export const REQUEST_UPDATE_COMPUTE_PROGRESS_METRIC = "request_update_compute_progress_metric"
export const UPDATE_COMPUTE_PROGRESS_METRIC_SUCCESS = "update_compute_progress_metric_success"
export const UPDATE_COMPUTE_PROGRESS_METRIC_FAILURE = "update_compute_progress_metric_failure"

export const CLEAR_UPDATE_COMPUTE_PROGRESS_METRIC = "clear_update_compute_progress_metric"